(function () {
    "use strict";

    var serviceId = "bolgeselDataService";
    angular
        .module("app.common")
        .factory(serviceId, [
            "$window",
            "$rootScope",
            "$q",
            "appActivitySvc",
            "yandexReverseGeocode",
            "mapOptionsService",
            "$translate",
            "geoApi",
            "$location",
            // "megaProjectApi",
            "$timeout",
            "$interval",
            "parcelClientService",
            bolgeselDataService
        ]);

    function bolgeselDataService(
        $window,
        $rootScope,
        $q,
        appActivitySvc,
        yandexReverseGeocode,
        mapOptionsService,
        $translate,
        geoApi,
        $location,
        // megaProjectApi,
        $timeout,
        $interval,
        parcelClientService
    ) {
        var service = {
            stats: {},
            places: {},
            initialize: initialize,
            isInvestmentAvailable: isInvestmentAvailable,
            isRegionReportAvailable: isRegionReportAvailable,
            menuItems: menuItems,
            removeStyle: removeStyle,
            updateIndices: updateIndices,
            updateElections: updateElections,
            updateDemography: updateDemography,
            updateFellows: updateFellows,
            updatePortfolio: updatePortfolio,
            updateMalls: updateMalls,
            updateLocations: updateLocations,
            updateProjects: updateProjects,
            updateOpportunities: updateOpportunities,
            updateAgents: updateAgents,
            updateQuakes: updateQuakes,
            updateInvestments: updateInvestments,
            // restrictView: false,
            wktData: {},
            cleanAddress: {},
            nearLayer: null,
            revGeo: revGeo,
            center: {
                zoom: 3,
            },
            bounds: {
                // "northEast": {
                //     "lat": 42.10480080000019,
                //     "lng": 44.81603587600034
                // },
                // "southWest": {
                //     "lat": 35.808715305999954,
                //     "lng": 25.66549954000005
                // }
            },
            cityBounds: {},
            defaults: {
                lat: 39.1667,
                lng: 35.6667,
                level: 0,
            },
            legendValues: {
                min: 0,
                max: 0,
                marker: "x/m²",
                label: "Birim Fiyat",
            },
            markers: {},
            loaded: {
                //places: false,
                stats: false,
            },
            geojson: {
                data: [],
                style: null
            },
            zoomToBound: zoomToBound,
            currentMap: {},
            // megaProjects: {},
            registerObserverCallback: registerObserverCallback,
            registerInitObserver: registerInitObserver,
            debounceInitObserver: debounceInitObserver,
            context: {
                goText: null,
                menuClick: null,
                addMarker: null,
            },
            level: null,
            $$IsInside: $$IsInside,
            refresh: refresh
        };

        service.currentColors = [];

        //indices defaults to centralize
        service.lastQuery = {};
        service.defaultDynamicQuery = {
            //years
            FrontTimePeriod: 3, //front end timechange
            // Tip:  Konut:1 , Ticari:2, Arsa: 3
            PropertyCategory: 1,

            //  Durumu Satılık:1 - Kiralık:2
            PropertyPriceType: 1,

            //  Fiyat filtresi: Satılık m2 Fiyat:1 - Satılık Fiyat:2 - Amortisman Süresi:3
            PriceFilter: 1,

            //  Bina Yaşı 1-4:1 - 5-10:2 - 11-15:3 - 16 ve Üzeri:4 - hepsi:5
            BuildYear: 5,

            //  Oda Sayisi 1+1:1 - 2+1:2 - 3+1:3 - 4+1:4 - hepsi:5
            Rooms: 5,

            //Bulunduğu kat giriş altı:1 - giriş:2 - ara:3 - en üst:4 - hepsi:5
            FloorNumber: 5,

            // Isıtma Doğalgaz:1 - Merkezi:2 - Hepsi:3
            HeatType: 3,

            //Emlak kategori Apartman Dairesi:1 Rezidans :2 Müstakil:3 hepsi:4 -> 2 is not functioning for now
            PropertyType: 4,

            // Site durumu Tümü:null - Site İçi:1 - Site Dışı:0 (only Turkey + housing, dynamictrend only)
            ComplexCategory: null,

            //Lat: null,
            //Long: null,

            //Level 0: Point, Level 1: City, Level 2: County, Level 3: District, Level 4: Drawing, Level 5: Turkey, Level 23: Spain Quarter
            Level: 1,

            //send geometry object for drawing in Level 4
            Wkt: "",
            Static: true,
            Trend: true,
            Details: true,
            Types: true,
        };

        //obeserver operations to call dedicated callbacks
        var observerCallbacks = [];
        var notifyObservers = function (geojsonRefresh, megaProjectsRefresh) {
            var index, len;
            for (index = 0, len = observerCallbacks.length; index < len; ++index) {
                observerCallbacks[index](geojsonRefresh, megaProjectsRefresh);
            }
            // angular.forEach(observerCallbacks, function (callback) {
            //     callback(geojsonRefresh, megaProjectsRefresh);
            // });
        };
        // Spain and Portugal have no investment listings (ES-4373).
        function isInvestmentAvailable() {
            var feature = service.stats && service.stats.features && service.stats.features[0];
            var countryId = feature && feature.properties && +feature.properties.CountryId;
            if (countryId) return countryId !== 2 && countryId !== 3;
            return $rootScope.country !== 'espana' && $rootScope.country !== 'portugal';
        }

        // Region reports exist only for Turkey; EU locations (ES/PT) must not offer them.
        function isRegionReportAvailable() {
            var feature = service.loaded.stats && service.stats.features && service.stats.features[0];
            var countryId = feature && feature.properties && feature.properties.CountryId;
            return countryId ? countryId === 1 : $rootScope.country === 'turkiye';
        }

        function menuItems(items) {
            if (isRegionReportAvailable()) return items;
            var filtered = items.filter(function (item) {
                return !item.regionReport;
            });
            return filtered.filter(function (item, i, arr) {
                return item !== '-' || (i > 0 && i < arr.length - 1 && arr[i - 1] !== '-');
            });
        }

        function debounceObserver(callback) {
            if (observerCallbacks && observerCallbacks.indexOf(callback) === -1)
                return false;

            const index = observerCallbacks.indexOf(callback);
            if (index > -1) {
                observerCallbacks.splice(index, 1);
            }
        }
        function registerObserverCallback(callback) {
            if (observerCallbacks && observerCallbacks.indexOf(callback) > -1)
                return false;
            observerCallbacks.push(callback);
        }

        var initObservers = [];
        function registerInitObserver(callback) {
            if (initObservers && initObservers.indexOf(callback) > -1)
                return false;
            initObservers.push(callback);
        }
        function debounceInitObserver(callback) {
            if (initObservers && initObservers.indexOf(callback) === -1)
                return false;

            const index = initObservers.indexOf(callback);
            if (index > -1) {
                initObservers.splice(index, 1);
            }
        }
        var notifyInitObservers = function () {
            try {
                var index, len;
                for (index = 0, len = initObservers.length; index < len; ++index) {
                    initObservers[index]();
                }
            } catch (err) {
                console.log(err);
                //ignored
            }
        };

        var checkLoad = function () {
            var deferred = $q.defer();
            var stop = $interval(function () {
                if (typeof L !== 'undefined') {
                    $interval.cancel(stop);
                    deferred.resolve();
                }
            }, 1);
            return deferred.promise;
        };


        service.debounceObserver = debounceObserver;

        return service;

        //initialization operations
        function initialize(lat, lng, level, region, geocode) {
            var deferred = $q.defer();
            $rootScope.loadingGeometries = true;
            service.loaded.stats = false;

            checkLoad().then(function () {
                //set window label
                var lt = $window.userStorage.getItem('labeltype');
                if (lt && lt === 'true')
                    window.permanent = true;

                //default center
                service.defaults.lat = lat;
                service.defaults.lng = lng;
                service.defaults.level = +level;

                service.legendValues.max = 0;
                service.legendValues.min = 0;

                if (window.location.href.indexOf('quake') === -1)
                    placeMarker(lat, lng, level, geocode);

                //analize stats data
                loadStats(lat, lng, level, region, geocode).then(
                    function () {
                        $rootScope.loadingGeometries = false;

                        // var restrictions = $window.userStorage.getItem('map_restriction');
                        // restrictions = restrictions ? JSON.parse(restrictions) : [];

                        // var allowed = false;
                        // for (var y = 0; y < restrictions.length; y++) {
                        //     var current = restrictions[y];
                        //     var first = service.stats.features[0].properties;
                        //     if (current.city && first.CityId === +current.city.split(':')[0])
                        //         allowed = true;
                        //     if (current.county && first.CountyId === +current.county.split(':')[0])
                        //         allowed = true;
                        //     if (current.district && first.DistrictId === +current.district.split(':')[0])
                        //         allowed = true;
                        // }

                        // service.restrictView = restrictions.length > 0 ? !allowed : false;
                        service.loaded.stats = true;
                        // getMegaProjects();
                        deferred.resolve(service.stats);
                        notifyInitObservers();

                    },
                    function (error) {
                        $rootScope.loadingGeometries = false;
                        service.loaded.stats = true;
                        notifyObservers();
                        deferred.reject(error);
                    }
                );
            });
            return deferred.promise;
        }

        function placeMarker(lat, lng, type, geocode) {
            var key;
            var isSpainDistrict = geocode && (+geocode.countryId === 2) && type === 3;
            for (key in service.markers) {
                if (service.markers.hasOwnProperty(key)) {
                    delete service.markers[key];
                }
            }
            if (!isSpainDistrict && (type === 0 || type === 5 || type === 3 || type === 8)) {
                var a = mapOptionsService.getMarker(lat, lng, false);
                for (key in a) {
                    if (a.hasOwnProperty(key)) {
                        a.m1.draggable = true;
                        service.markers[key] = a[key];
                    }
                }
            }
            // if (type === 0 || type === 5) {
            //     //    var rootLoc = typeof $window.location.origin !== 'undefined' ?
            //     //        $window.location.origin : 'https://www.endeksa.com';
            //     //    if (rootLoc.indexOf('/undefined') > -1)
            //     //        rootLoc = rootLoc.replace('/undefined', '');

            //     //    var langKey = window.lang || 'tr';
            //     //    if (window.rememberProperty) {
            //     //        var url = makeValuation(window.rememberProperty);
            //     //        if (langKey === 'tr') {
            //     //            var message = '<a href="' + url + '" target="_blank" style="color: white; font-size:14px; margin-left: 4px; padding-left: 4px; padding-top: 7px; padding-right: 14px;" class="landing-button closed"><i class="landingicon-4"></i> İlanın Değerini Öğren</a>';
            //     //        } else if (langKey === 'en') {
            //     //            message = '<a href="' + url + '" target="_blank" style="color: white; font-size:14px; margin-left: 4px; padding-left: 4px; padding-top: 7px; padding-right: 14px;" class="landing-button closed"><i class="landingicon-4"></i> Evaluate This Listing</a>';
            //     //        }
            //     //    }
            //     //    else {
            //     //        if (langKey === 'tr') {
            //     //            var query = "evimin-degeri";
            //     //            var qlang = "Evimin Değeri";
            //     //            var ilang = "landingicon-4";
            //     //            if (params.konut === "arsa" || params.konut === "plot") {
            //     //                query = "arsamin-degeri";
            //     //                qlang = "Arsamın Değeri";
            //     //                ilang = "landingicon-5";
            //     //            }
            //     //            message = '<a href="' + rootLoc + '/tr/' + query + '/ogren/' +
            //     //                lat.toString().replace('.', ',') + ';' + lng.toString().replace('.', ',') +
            //     //                '" target="_blank" style="color: white; font-size:14px; margin-left: 4px; padding-left: 4px; padding-top: 7px; padding-right: 14px;" class="landing-button closed"><i class="' + ilang + '"></i> ' + qlang + '</a>';
            //     //        } else {
            //     //            query = "evimin-degeri";
            //     //            qlang = "Calculate House Value";
            //     //            ilang = "landingicon-4";
            //     //            if (params.konut === "arsa" || params.konut === "plot") {
            //     //                query = "arsamin-degeri";
            //     //                qlang = "Calculate Plot Value";
            //     //                ilang = "landingicon-5";
            //     //            }
            //     //            message = '<a href="' + rootLoc + '/en/' + query + '/ogren/' +
            //     //                lat.toString().replace('.', ',') + ';' + lng.toString().replace('.', ',') +
            //     //                '" target="_blank" style="color: white; font-size:14px; margin-left: 4px; padding-left: 4px; padding-top: 7px; padding-right: 14px;" class="landing-button closed"><i class="' + ilang + '"></i> ' + qlang + '</a>';
            //     //        }
            //     //    }

            //     //    message = message + '<style>.leaflet-popup-close-button { display: none; background: white !important; border-radius: 10px !important; padding: 2px !important; height: auto !important; width: auto !important; } .leaflet-popup-tip-container { display: none } .leaflet-popup-content { width: auto !important; padding:0 } .leaflet-popup-content-wrapper { background: transparent; box-shadow: none; padding:0; padding-left:7px; margin-left:3px; margin-bottom:-2px}</style>';

            //     //    if (isHiddenMessage)
            //     var message = false;

            //     a = mapOptionsService.getMarker(lat, lng, message);

            //     for (key in a) {
            //         if (a.hasOwnProperty(key)) {
            //             a.m1.draggable = true;
            //             service.markers[key] = a[key];
            //         }
            //     }
            // } else if (type === 3) {
            //     a = mapOptionsService.getMarker(lat, lng, false);
            //     for (key in a) {
            //         if (a.hasOwnProperty(key)) {
            //             a.m1.draggable = true;
            //             service.markers[key] = a[key];
            //         }
            //     }
            // }
        }

        function refresh() {
            bindLayer(service.stats, service.defaults.level, service.defaults.lat, service.defaults.lng);
        }

        function bindLayer(resb, level, lat, lng) {


            const countryId = resb.features[0].properties.CountryId;
            const countyId = resb.features[0].properties.CountyId;
            const cityId = resb.features[0].properties.CityId;
            const districtId = resb.features[0].properties.DistrictId;
            const quarterId = resb.features[0].properties.QuarterId;
            const parcelId = resb.features[0].properties.ParcelId;

            service.defaultDynamicQuery.Level = +level;
            if (+level === 0 || +level === 4 || +level === 5) {
                service.defaultDynamicQuery.Lat = lat;
                service.defaultDynamicQuery.Long = lng;
                delete service.defaultDynamicQuery.QuarterId;
            } else {
                // delete service.defaultDynamicQuery.Lat;
                // delete service.defaultDynamicQuery.Long;
                service.defaultDynamicQuery.CountryId = countryId;
                service.defaultDynamicQuery.CountyId = countyId;
                service.defaultDynamicQuery.CityId = cityId;
                // At Spain quarter level (23) the child features carry individual district IDs;
                // sending one of them as DistrictId would scope the query incorrectly.
                // QuarterId is the meaningful filter at this level.
                if (+level === 23) {
                    delete service.defaultDynamicQuery.DistrictId;
                    service.defaultDynamicQuery.QuarterId = quarterId;
                } else {
                    service.defaultDynamicQuery.DistrictId = districtId;
                    if (quarterId)
                        service.defaultDynamicQuery.QuarterId = quarterId;
                    else
                        delete service.defaultDynamicQuery.QuarterId;
                }
                // BlockId is not used by dynamictrend API
                service.defaultDynamicQuery.ParcelId = parcelId;
            }

            service.poly = null;
            var geo = L.geoJson(service.stats);

            var obounds = geo.getBounds();
            var lobounds = {
                northEast: {
                    lat: obounds._northEast.lat,
                    lng: obounds._northEast.lng,
                },
                southWest: {
                    lat: obounds._southWest.lat,
                    lng: obounds._southWest.lng,
                },
            };
            service.bounds = lobounds;

            if (level === 1 || level === 9) {
                service.country = normalizeAddress(resb.features[0].properties.Country);
                service.cityBounds = lobounds;
            }
            else if (level === 10) {
                service.country = 'world';
                service.cityBounds = {};
            }
            try {
                service.poly = geo.getLayers()[0]._latlngs[0];
            } catch (err) {
                console.error(err);
            }
            service.geojson.data = [service.stats];
            // service.geojson.style = style;

            removeStyle(true);




            service.geojson.pointToLayer = function (feature, latlng) {
                return null;
            };

            if (level === 8) {
                parcelClientService.asignParcelProperties(resb.features[0]);
            }

            if (level === 10)
                $rootScope.country = 'world';
            else
                $rootScope.country = normalizeAddress(resb.features[0].properties.Country);


            var altLevel = null;
            switch (+level) {
                case 9:
                    altLevel = 10;
                    break;
                case 0:
                case 3:
                case 6:
                case 5:
                    altLevel = 2;
                    break;
                case 7:
                    altLevel = 6;
                    break;
                case 8:
                    altLevel = 7;
                    break;
                case 2:
                    altLevel = 1;
                    break;
            }

            if (service.geoApAltCity)
                service.geoApAltCity.$cancelRequest();

            if (service.geoApAlt)
                service.geoApAlt.$cancelRequest();

            if (service.geoApAlt2)
                service.geoApAlt2.$cancelRequest();

            if (+level !== 10 && +level !== 9 && +level !== 1) {
                service.geoApAltCity = geoApi.get({
                    // Lat: +lat,
                    // Long: +lng,
                    level: 1,
                    countryId: countryId,
                    cityId: cityId,
                    subGeometries: true
                });
                service.geoApAltCity.$promise.then(
                    function (resa) {
                        var geo = L.geoJson(resa);
                        var bounds = geo.getBounds();
                        var lbounds = {
                            northEast: {
                                lat: bounds._northEast.lat,
                                lng: bounds._northEast.lng,
                            },
                            southWest: {
                                lat: bounds._southWest.lat,
                                lng: bounds._southWest.lng,
                            },
                            // name: resa.features[0].properties.City
                        };
                        service.country = normalizeAddress(resa.features[0].properties.Country);
                        service.cityBounds = lbounds;
                    },
                    function (result) {
                        if (result.xhrStatus !== 'abort')
                            console.log(result);
                    }
                );

            }

            if (+level !== 10 && +level !== 1 && +level !== 11 && altLevel !== null) {
                service.geoApAlt = geoApi.get({
                    // Lat: +lat,
                    // Long: +lng,
                    level: altLevel,
                    countryId: countryId,
                    cityId: cityId,
                    countyId: countyId,
                    districtId: districtId,
                    subGeometries: true
                });
                service.geoApAlt.$promise.then(
                    function (resa) {
                        var result = [];
                        for (var y = 0; y < resa.features.length; y++) {
                            resa.features[y].properties.description = $translate.instant(resa.features[y].properties.description);
                            if (
                                altLevel === 2 &&
                                (!resa.features[y].properties.DistrictId || resa.features[y].properties.DistrictId === districtId)
                            ) {
                                //pass this object
                            } else if (
                                altLevel === 1 &&
                                (!resa.features[y].properties.CountyId || resa.features[y].properties.CountyId === countyId)
                            ) {
                                //pass this object
                            } else if (
                                altLevel === 10 &&
                                (!resa.features[y].properties.CountryId || resa.features[y].properties.CountryId === countryId)
                            ) {
                                //pass this object
                            } else if (
                                altLevel === 6 &&
                                (!resa.features[y].properties.BlockId || resa.features[y].properties.BlockId === blockId)
                            ) {
                                //pass this object
                            } else if (
                                altLevel === 7 &&
                                (!resa.features[y].properties.ParcelId || resa.features[y].properties.ParcelId === parcelId)
                            ) {
                                //pass this object
                            } else {
                                result.push(resa.features[y]);
                            }
                        }
                        var geo = L.geoJson(result, {
                            style: {
                                fillColor: "transparent",
                                weight: 0.7,
                                opacity: 1,
                                color: "#e5e5e5",
                                dashArray: "2",
                                fillOpacity: 0,

                            },
                            onEachFeature: function (feature, layer) {
                                var desc = feature.properties.description;
                                if (altLevel === 2)
                                    desc =
                                        desc + " (" + feature.properties.County + ")";
                                if (desc) layer.bindTooltip(desc, { sticky: window.permanent ? false : true, permanent: window.permanent, direction: window.permanent ? 'center' : null, className: window.permanent ? 'polygon-labels' : null });
                                layer.level = altLevel;
                                layer.on("click", function (e) {
                                    var data = {
                                        leafletObject: layer,
                                        leafletEvent: e,
                                        level: altLevel,
                                        alt: true,
                                    };
                                    if (!$window.hasAllowance)
                                        $rootScope.$broadcast(
                                            "leafletDirectiveGeoJson.main-map.click",
                                            data
                                        );
                                    if (layer._map) {
                                        layer._map.contextmenu.hide();
                                    }
                                });
                                layer.bindContextMenu({
                                    contextmenu: true,
                                    contextmenuItems: [{
                                        text:
                                            !$window.hasAllowance ?
                                                altLevel === 1 && feature.properties.County ?
                                                    $window.cekimEki(
                                                        feature.properties.County.split(
                                                            " ("
                                                        )[0],
                                                        "e"
                                                    ) + $translate.instant(" Git") :
                                                    altLevel === 2 && feature.properties.District ?
                                                        $window.cekimEki(
                                                            feature.properties.District.split(
                                                                " ("
                                                            )[0],
                                                            "e"
                                                        ) + $translate.instant(" Git") :
                                                        altLevel === 9 && feature.properties.City ?
                                                            $window.cekimEki(
                                                                feature.properties.City.split(
                                                                    " ("
                                                                )[0],
                                                                "e"
                                                            ) + $translate.instant(" Git") : altLevel === 6 && feature.properties.BlockNo ?
                                                                $window.cekimEki(
                                                                    feature.properties.BlockNo + " " + $translate.instant("Ada"),
                                                                    "e"
                                                                ) + $translate.instant(" Git") : altLevel === 7 && feature.properties.ParcelNo ?
                                                                    $window.cekimEki(
                                                                        feature.properties.BlockNo + '/' + feature.properties.ParcelNo + " " + $translate.instant("Parsel"),
                                                                        "e"
                                                                    ) + $translate.instant(" Git") :
                                                                    "" : "",
                                        iconCls:
                                            !$window.hasAllowance ?
                                                (altLevel === 1 ||
                                                    altLevel === 2 ||
                                                    altLevel === 9 ||
                                                    altLevel === 6 ||
                                                    altLevel === 7) ?
                                                    "ei-apartment" :
                                                    "" : "",
                                        callback: function (e) {
                                            var feature = e.relatedTarget.feature;
                                            service.context.goText(feature, altLevel);
                                        },
                                    },
                                    {
                                        text:
                                            !$window.hasAllowance ?
                                                $translate.instant("Konuma Git") : "",
                                        iconCls:
                                            !$window.hasAllowance ?
                                                "ei-location" : "",
                                        callback: function (e) {
                                            service.context.menuClick(e);
                                        },
                                    },
                                        "-",
                                    {
                                        text: $translate.instant("Yaklaş"),
                                        iconCls: "ei-zoom-in",
                                        callback: function (e) {
                                            var latlng = e.latlng;
                                            service.defaults.lat = latlng.lat;
                                            service.defaults.lng = latlng.lng;
                                            service.center.zoom = service.center.zoom + 1;
                                        },
                                    },
                                    {
                                        text: $translate.instant("Uzaklaş"),
                                        iconCls: "ei-zoom-out",
                                        callback: function (e) {
                                            var latlng = e.latlng;
                                            service.defaults.lat = latlng.lat;
                                            service.defaults.lng = latlng.lng;
                                            service.center.zoom = service.center.zoom - 1;
                                        },
                                    }
                                    ]
                                });
                            },
                        });
                        geo.addTo(service.nearLayer);

                        if (altLevel === 2) {
                            service.geoApAlt2 = geoApi.get({
                                // Lat: +lat,
                                // Long: +lng,
                                level: 1,
                                countryId: countryId,
                                cityId: cityId,
                                subGeometries: true
                            });
                            service.geoApAlt2.$promise.then(
                                function (resa) {
                                    var result = [];
                                    for (var y = 0; y < resa.features.length; y++) {
                                        resa.features[y].properties.description = $translate.instant(resa.features[y].properties.description);

                                        if (
                                            altLevel === 2 &&
                                            resa.features[y].properties.CountyId ===
                                            countyId
                                        ) {
                                            //pass this object
                                        } else {
                                            result.push(resa.features[y]);
                                        }
                                    }
                                    var geo = L.geoJson(result, {
                                        style: {
                                            fillColor: "transparent",
                                            weight: 0.7,
                                            opacity: 1,
                                            color: "#e5e5e5",
                                            dashArray: "2",
                                            fillOpacity: 0,

                                        },
                                        onEachFeature: function (feature, layer) {
                                            var desc = feature.properties.description;
                                            if (desc)
                                                layer.bindTooltip(desc, { sticky: window.permanent ? false : true, permanent: window.permanent, direction: window.permanent ? 'center' : null, className: window.permanent ? 'polygon-labels' : null });
                                            layer.level = 1;
                                            layer.on("click", function (e) {
                                                var data = {
                                                    leafletObject: layer,
                                                    leafletEvent: e,
                                                    level: 1,
                                                    alt: true,
                                                };
                                                if (!$window.hasAllowance)
                                                    $rootScope.$broadcast(
                                                        "leafletDirectiveGeoJson.main-map.click",
                                                        data
                                                    );
                                                if (layer._map) {
                                                    layer._map.contextmenu.hide();
                                                }
                                            });
                                            layer.bindContextMenu({
                                                contextmenu: true,
                                                contextmenuItems: [{
                                                    text:
                                                        !$window.hasAllowance ?
                                                            $window.cekimEki(
                                                                feature.properties.County.split(
                                                                    " ("
                                                                )[0], "e") + $translate.instant(" Git") : "",
                                                    iconCls:
                                                        !$window.hasAllowance ?
                                                            "ei-apartment" : "",
                                                    callback: function (e) {
                                                        var feature = e.relatedTarget.feature;
                                                        service.context.goText(feature, 1);
                                                    },
                                                },
                                                {
                                                    text:
                                                        !$window.hasAllowance ?
                                                            $translate.instant("Konuma Git") : "",
                                                    iconCls:
                                                        !$window.hasAllowance ?
                                                            "ei-location" : "",
                                                    callback: function (e) {
                                                        service.context.menuClick(e);
                                                    },
                                                },
                                                    "-",
                                                {
                                                    text: $translate.instant("Yaklaş"),
                                                    iconCls: "ei-zoom-in",
                                                    callback: function (e) {
                                                        var latlng = e.latlng;
                                                        service.defaults.lat = latlng.lat;
                                                        service.defaults.lng = latlng.lng;
                                                        service.center.zoom =
                                                            service.center.zoom + 1;
                                                    },
                                                },
                                                {
                                                    text: $translate.instant("Uzaklaş"),
                                                    iconCls: "ei-zoom-out",
                                                    callback: function (e) {
                                                        var latlng = e.latlng;
                                                        service.defaults.lat = latlng.lat;
                                                        service.defaults.lng = latlng.lng;
                                                        service.center.zoom =
                                                            service.center.zoom - 1;
                                                    },
                                                }
                                                ]
                                            });
                                        },
                                    });
                                    geo.addTo(service.nearLayer);
                                },
                                function (result) {
                                    if (result.xhrStatus !== 'abort')
                                        console.log(result);
                                }
                            );
                        }
                    },
                    function (result) {
                        if (result.xhrStatus !== 'abort')
                            console.log(result);
                    }
                );
            }
        }

        //internal operations
        function loadStats(lat, lng, level, region, geocode) {
            appActivitySvc.busy("bolgeselDataService");
            var deferred = $q.defer();

            // try {
            //     service.polyOld = null;
            //     var geo = L.geoJson(service.stats);
            //     service.polyOld = geo.getLayers()[0]._latlngs[0];
            // } catch (err) {
            //     //ignored
            // }

            if (service.geoAp)
                service.geoAp.$cancelRequest();

            $$IsInside(lat, lng, service.poly, level).then(function (inside) {
                if (!inside) {
                    if (service.nearLayer)
                        service.nearLayer.clearLayers();

                    service.level = level;

                    var payload = { level: level };
                    if (geocode) {
                        payload.countryId = geocode.countryId;
                        payload.cityId = geocode.cityId;
                        payload.countyId = geocode.countyId;
                        payload.districtId = geocode.districtId;
                        payload.quarterId = geocode.quarterId;
                        payload.parcelId = geocode.parcelId;
                        payload.blockId = geocode.blockId;
                        payload.subGeometries = true;
                    }
                    else {
                        payload.lat = +lat;
                        payload.long = +lng;
                    }

                    if (region)
                        payload.RegionId = region;

                    if (!service.preLoaded) {
                        service.geoAp = geoApi.get(payload);
                        service.geoAp.$promise
                            .then(
                                function (resb) {
                                    service.stats = resb;
                                    bindLayer(resb, level, lat, lng);
                                    deferred.resolve();
                                },
                                function (result) {
                                    if (result.xhrStatus !== 'abort')
                                        deferred.reject(result);
                                }
                            )["finally"](function () {
                                appActivitySvc.idle("bolgeselDataService");
                            });
                    }
                    else {
                        service.stats = angular.copy(service.preLoaded);
                        bindLayer(service.stats, level, lat, lng);
                        service.preLoaded = null;
                        deferred.resolve();
                    }
                } else {
                    appActivitySvc.idle("bolgeselDataService");
                    deferred.resolve();
                }
            });
            return deferred.promise;
        }

        // function getMegaProjects() {
        //     var query = {
        //         CityId: service.stats.features[0].properties.CityId,
        //         CountyId: service.stats.features[0].properties.CountyId,
        //         Level: 1,
        //         Lat: service.defaultDynamicQuery.Lat,
        //         Long: service.defaultDynamicQuery.Long,
        //     };

        //     var req2 = megaProjectApi.get(query);
        //     req2.$promise.then(function (response) {
        //         service.megaProjects = response;
        //         notifyObservers(false, true);
        //     });
        // }

        function continueRev(stat, formattedAdres, deferred) {
            const il = stat.features[0].properties.City.toLocaleUpperCase("tr-tr");
            const ilce = stat.features[0].properties.County.toLocaleUpperCase(
                "tr-tr"
            );
            const mah = stat.features[0].properties.District.toLocaleUpperCase(
                "tr-tr"
            );

            if (formattedAdres) {
                service.cleanAddress.address = formattedAdres;

                var regex = new RegExp(
                    "(^|[^wığüşöçĞÜŞÖÇİ])(" + il + ")([^wığüşöçĞÜŞÖÇİ]|$)",
                    "ig"
                );
                service.cleanAddress.address = service.cleanAddress.address
                    .toLocaleUpperCase("tr-tr")
                    .replace(regex, "");

                var regex2 = new RegExp(
                    "(^|[^wığüşöçĞÜŞÖÇİ])(" + ilce + ")([^wığüşöçĞÜŞÖÇİ]|$)",
                    "ig"
                );
                service.cleanAddress.address = service.cleanAddress.address
                    .toLocaleUpperCase("tr-tr")
                    .replace(regex2, "");

                var regex3 = new RegExp(
                    "(^|[^wığüşöçĞÜŞÖÇİ])(" + mah + ")([^wığüşöçĞÜŞÖÇİ]|$)",
                    "ig"
                );
                service.cleanAddress.address = service.cleanAddress.address
                    .toLocaleUpperCase("tr-tr")
                    .replace(regex3, "");

                service.cleanAddress.address = service.cleanAddress.address.replaceAllString(
                    ",",
                    ""
                );
                service.cleanAddress.address = service.cleanAddress.address.replaceAllString(
                    "//",
                    ""
                );
                service.cleanAddress.address = service.cleanAddress.address.replaceAllString(
                    "MH.",
                    ""
                );
                service.cleanAddress.address = service.cleanAddress.address.replaceAllString(
                    "MAH.",
                    ""
                );
                service.cleanAddress.address = service.cleanAddress.address.replaceAllString(
                    "LLESİ",
                    ""
                );

                service.cleanAddress.address = service.cleanAddress.address.replaceAllString(
                    "CİTY OF",
                    ""
                ).trim();

                service.cleanAddress.address = service.cleanAddress.address.toLocaleProperCase2("tr-tr");

                if (!service.cleanAddress.address)
                    service.cleanAddress.address = window.lang === 'tr' ? "Seçili Konum" : window.lang === 'es-ES' ? "Ubicación Seleccionada" : window.lang === 'pt-PT' ? "Local Selecionado" : "Selected Location";

                notifyObservers();
                deferred.resolve(service.cleanAddress);
            } else {
                service.cleanAddress.address = "";
                notifyObservers();
                deferred.resolve(service.cleanAddress.address);
            }
        }

        function revGeo(stat, lat, lng) {
            var deferred = $q.defer();
            if (window.isHeadless())
                continueRev(stat, "", deferred);
            else
                // if ($rootScope.country === 'turkiye')
                yandexReverseGeocode.geocodeLatlng(lat, lng).then(
                    function (formattedAdres) {
                        continueRev(stat, formattedAdres, deferred);
                    },
                    function () {
                        service.cleanAddress.address = $translate.instant('dataservice_unknown');
                        notifyObservers();
                        deferred.resolve(service.cleanAddress.address);
                    }
                );

            return deferred.promise;
        }

        // Matches a map feature id to a thematic API row by the current map level.
        // Spain county pages (level 2) list quarter features whose feature.id is a
        // QuarterId; thematic rows carry QuarterId > 0 only for Spain, so Turkey
        // keeps matching by DistrictId. Level 23 (Spain quarter page) features are
        // districts, so the DistrictId fallback stays correct there.
        function matchThematicRow(level, geoId, row) {
            if (level === 1) return geoId === row.CountyId;
            if (level === 10) return geoId === row.CountryId;
            if (level === 9) return geoId === row.CityId;
            if (level === 2 && row.QuarterId) return geoId === row.QuarterId;
            return geoId === row.DistrictId;
        }

        function updateDemography(data, graphType, data2, wholeData) {
            if (graphType === "hemsehrilik") return false;

            removeStyle();
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            service.currentColorNumber = 0;
            service.currentColors = [];
            var marker = " " + $translate.instant("demographics_population_title");
            var label = $translate.instant("demographic_population");

            for (var y = 0, len = service.stats.features.length; y < len; y++) {
                var value1 = service.stats.features[y];
                var key1 = y;
                if (!service.stats.features[key1].properties)
                    continue;

                if (!service.stats.features[key1].properties.defaultText) {
                    service.stats.features[key1].properties.defaultText =
                        service.stats.features[key1].properties.description;
                } else {
                    service.stats.features[key1].properties.description =
                        service.stats.features[key1].properties.defaultText;
                }
                if (data)
                    for (var i = 0, lent = data.length; i < lent; i++) {
                        var value2 = data[i];
                        var geoId = parseInt(value1.id);
                        if (
                            geoId === 0 && service.defaults.level !== 1 && service.defaults.level !== 9 && service.defaults.level !== 10 ?
                                value1.properties.District.replace(' Köyü', '') === value2.RegionName :
                                matchThematicRow(service.defaults.level, geoId, value2)
                        ) {
                            var result;
                            if (graphType === "yas") {
                                result = value2.AgeGroupDensity;
                                service.stats.features[key1].properties.value = result;
                                //if (+result === 65)
                                //    marker = $translate.instant('above_age');
                                //else
                                //    marker = $translate.instant('between_age');
                                marker = $translate.instant("between_age");
                                label = $translate.instant("mostly_seen");
                            } else if (graphType === "medeni-hal") {
                                result = value2.MaritalDensity;
                                result = $translate.instant(result);
                                service.stats.features[key1].properties.value = result;
                                marker = "";
                                label = $translate.instant("demographics_pill3");
                            } else if (graphType === "ses") {
                                result = $translate.instant(value2.SESDensity);
                                service.stats.features[key1].properties.value = result;
                                marker = ""; //$translate.instant('demographic_group');
                                label = $translate.instant("demographics_pill5");
                            } else if (graphType === "egitim") {
                                result = $translate.instant(value2.EducationDensity);
                                service.stats.features[key1].properties.value = result;
                                marker = "";
                                label = $translate.instant("demographics_pill4");
                            } else if (graphType === "detay" || graphType === "gelir") {
                                service.stats.features[key1].properties.value =
                                    value2.HouseHold;
                                result = window.lang === 'tr' ? (+value2.HouseHold).formatMoney(0, ",", ".") : (+value2.HouseHold).formatMoney(0, ".", ",");
                                marker =
                                    " " + $translate.instant("demographics_population_title");
                                label = $translate.instant("demographics_subpill1");
                            } else if (graphType === "satis") {
                                service.stats.features[key1].properties.value =
                                    value2.TotalSale;
                                result = window.lang === 'tr' ? (+value2.TotalSale).formatMoney(0, ",", ".") : (+value2.TotalSale).formatMoney(0, ".", ",");
                                marker = " " + $translate.instant("demographics_piece");
                                label = $translate.instant("sales_count");
                            } else if (graphType === "konutisyeri") {
                                service.stats.features[key1].properties.value =
                                    value2.TotalEstate;
                                result = window.lang === 'tr' ? (+value2.TotalEstate).formatMoney(0, ",", ".") : (+value2.TotalEstate).formatMoney(0, ".", ",");
                                marker = " " + $translate.instant("demographics_piece");
                                label = $translate.instant("property_count");
                            } else if (graphType === "harcama") {
                                service.stats.features[key1].properties.value =
                                    value2.HouseIncome;
                                result = window.lang === 'tr' ? (+value2.HouseIncome).formatMoney(0, ",", ".") : (+value2.HouseIncome).formatMoney(0, ".", ",");
                                marker = " " + window.currencySymbol;
                                label = $translate
                                    .instant("demographics_perCapita")
                                    .toLocaleProperCase2('tr-tr');
                            } else if (graphType === "ecommerce") {
                                service.stats.features[key1].properties.value =
                                    value2.ECommerceDensity;
                                result = window.lang === 'tr' ? (+value2.ECommerceDensity).formatMoney(0, ",", ".") : (+value2.ECommerceDensity).formatMoney(0, ".", ",");
                                marker = " %";
                                label = $translate
                                    .instant("demographics_eCommerce")
                                    .toLocaleProperCase2('tr-tr');
                            } else {
                                service.stats.features[key1].properties.value =
                                    value2.PopulationTotal;
                                result = window.lang === 'tr' ? (+value2.PopulationTotal).formatMoney(0, ",", ".") : (+value2.PopulationTotal).formatMoney(0, ".", ",");
                                marker =
                                    " " + $translate.instant("demographics_population_title");
                                label = $translate.instant("demographics_pill1");
                            }
                            var text = service.stats.features[key1].properties.defaultText;
                            if (result && text) {
                                service.stats.features[key1].properties.description =
                                    text + " " + result + marker;
                            }
                        }
                    }
                if (data2)
                    for (var ir = 0, lentr = data2.length; ir < lentr; ir++) {
                        var value22 = data2[ir];
                        var geoIdr = parseInt(value1.id);
                        if (
                            service.defaults.level === 1 ?
                                geoIdr === value22.CountyId :
                                service.defaults.level === 10 ?
                                    geoIdr === value22.CountryId :
                                    service.defaults.level === 9 ?
                                        geoIdr === value22.CityId :
                                        geoIdr === value22.DistrictId
                        ) {
                            // result = value22.MaritalDensity;
                            result = $translate.instant(value22.MaritalDensity);
                            service.stats.features[key1].properties.value = result;
                            label = $translate.instant("demographics_pill6");
                            text = service.stats.features[key1].properties.defaultText;
                            if (result && text) {
                                service.stats.features[key1].properties.description =
                                    text + " " + result;
                            }
                        }
                    }
            }
            if (
                graphType === "yas" ||
                graphType === "medeni-hal" ||
                graphType === "ses" ||
                graphType === "egitim"
            ) {
                service.legendValues.max = 0;
                service.legendValues.min = 0;
                service.legendValues.marker = "";
                service.legendValues.label = "";

                var datas = [];
                for (var key in wholeData) {
                    if (wholeData[key] && typeof wholeData[key] === "object") {
                        datas.push({ key: key, data: wholeData[key].labels });
                    }
                }

                for (var p in service.stats.features) {
                    if (service.stats.features[p].properties) {
                        var searchFor = service.stats.features[p].properties.value;

                        var query = $translate.instant(searchFor);
                        var selected = datas.filter(function (item) {
                            return item.data && item.data.indexOf(query) > -1;
                        });
                        if (selected.length) {
                            var pIndex = selected[0].data.indexOf(searchFor);
                            service.stats.features[p].properties.color =
                                window.globalColors[pIndex];
                        }
                    }
                }

                //if (!analysisService.started)
                service.geojson.style = styleSelected;
                //else
                //    analysisService.oldStyle = styleSelected;
            } else {
                var minMaxArray = angular.copy(service.stats.features);
                minMaxArray.shift();
                minMaxArray = minMaxArray.filter(function (val) {
                    return val.properties.value && val.properties.value !== 0;
                });
                var min = Math.min.apply(
                    Math,
                    minMaxArray.map(function (item) {
                        return item.properties.value;
                    })
                );
                var max = Math.max.apply(
                    Math,
                    minMaxArray.map(function (item) {
                        return item.properties.value;
                    })
                );
                service.legendValues.max = max;
                service.legendValues.min = min;
                service.legendValues.marker = marker;
                service.legendValues.label = label;
                for (var t = 0, lenh = service.stats.features.length; t < lenh; t++) {
                    var value3 = service.stats.features[t];
                    value3.properties.min = min;
                    value3.properties.max = max;
                }
                //service.geojson.data = [service.stats];
                //if (!analysisService.started)
                service.geojson.style = style;
                //else
                //    analysisService.oldStyle = style;
            }
            notifyObservers(true);
        }

        function updateOpportunities(data) {
            removeStyle();
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            service.currentColorNumber = 0;
            service.currentColors = [];
            if (service.stats.features && data)
                for (var y = 0, len = service.stats.features.length; y < len; y++) {
                    var value1 = service.stats.features[y];
                    var key1 = y;
                    service.stats.features[key1].properties.value = 0;
                    if (!service.stats.features[key1].properties.defaultText) {
                        service.stats.features[key1].properties.defaultText =
                            service.stats.features[key1].properties.description;
                    } else {
                        service.stats.features[key1].properties.description =
                            service.stats.features[key1].properties.defaultText;
                    }
                    for (var i = 0, lent = data.length; i < lent; i++) {
                        var value2 = data[i];
                        var geoId = parseInt(value1.id);
                        if (matchThematicRow(service.defaults.level, geoId, value2)) {
                            var result = value2.PropertyCount;

                            service.stats.features[key1].properties.value = result;

                            var text = service.stats.features[key1].properties.defaultText;

                            if (result && text) {
                                service.stats.features[key1].properties.description =
                                    text +
                                    " " +
                                    result + " " + $translate.instant("dataservice_deals");
                            }
                        }
                    }
                }

            var minMaxArray = angular.copy(service.stats.features);
            minMaxArray.shift();
            minMaxArray = minMaxArray.filter(function (val) {
                return val.properties.value && val.properties.value !== 0;
            });
            var min = Math.min.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            var max = Math.max.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            service.legendValues.max = max;
            service.legendValues.min = min;
            service.legendValues.marker = $translate.instant("dataservice_deals");
            service.legendValues.label = $translate.instant("opport_error_filter");
            for (var t = 0, lenh = service.stats.features.length; t < lenh; t++) {
                var value3 = service.stats.features[t];
                value3.properties.min = min;
                value3.properties.max = max;
            }
            //service.geojson.data = [service.stats];
            //if (!analysisService.started)
            service.geojson.style = style;
            //else
            //    analysisService.oldStyle = style;
            notifyObservers(true);
        }

        function updateAgents(data) {
            removeStyle();
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            service.currentColorNumber = 0;
            service.currentColors = [];
            if (service.stats.features && data)
                for (var y = 0, len = service.stats.features.length; y < len; y++) {
                    var value1 = service.stats.features[y];
                    var key1 = y;
                    service.stats.features[key1].properties.value = 0;
                    if (!service.stats.features[key1].properties.defaultText) {
                        service.stats.features[key1].properties.defaultText =
                            service.stats.features[key1].properties.description;
                    } else {
                        service.stats.features[key1].properties.description =
                            service.stats.features[key1].properties.defaultText;
                    }
                    for (var i = 0, lent = data.length; i < lent; i++) {
                        var value2 = data[i];
                        var geoId = parseInt(value1.id);
                        if (matchThematicRow(service.defaults.level, geoId, value2)) {
                            var result = value2.RealtorCount;

                            service.stats.features[key1].properties.value = result;

                            var text = service.stats.features[key1].properties.defaultText;

                            if (result && text) {
                                service.stats.features[key1].properties.description =
                                    text +
                                    " " +
                                    result
                                    + " " + $translate.instant("dataservice_experts");
                            }
                        }
                    }
                }

            var minMaxArray = angular.copy(service.stats.features);
            minMaxArray.shift();
            minMaxArray = minMaxArray.filter(function (val) {
                return val.properties.value && val.properties.value !== 0;
            });
            var min = Math.min.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            var max = Math.max.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            service.legendValues.max = max;
            service.legendValues.min = min;
            service.legendValues.marker = $translate.instant("dataservice_experts");
            service.legendValues.label = $translate.instant("agent_error_filter");
            for (var t = 0, lenh = service.stats.features.length; t < lenh; t++) {
                var value3 = service.stats.features[t];
                value3.properties.min = min;
                value3.properties.max = max;
            }
            //service.geojson.data = [service.stats];
            //if (!analysisService.started)
            service.geojson.style = style;
            //else
            //    analysisService.oldStyle = style;
            notifyObservers(true);
        }

        function updateQuakes(data) {
            removeStyle();
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            service.currentColorNumber = 0;
            service.currentColors = [];
            if (service.stats.features && data)
                for (var y = 0, len = service.stats.features.length; y < len; y++) {
                    var value1 = service.stats.features[y];
                    var key1 = y;
                    service.stats.features[key1].properties.value = 0;
                    if (!service.stats.features[key1].properties.defaultText) {
                        service.stats.features[key1].properties.defaultText =
                            service.stats.features[key1].properties.description;
                    } else {
                        service.stats.features[key1].properties.description =
                            service.stats.features[key1].properties.defaultText;
                    }
                    for (var i = 0, lent = data.length; i < lent; i++) {
                        var value2 = data[i];
                        var geoId = parseInt(value1.id);
                        if (matchThematicRow(service.defaults.level, geoId, value2)) {
                            var result = value2.TweetCount;

                            service.stats.features[key1].properties.value = result;

                            var text = service.stats.features[key1].properties.defaultText;

                            if (result && text) {
                                service.stats.features[key1].properties.description =
                                    text +
                                    " " +
                                    result
                                    + " " + $translate.instant("dataservice_request");
                            }
                        }
                    }
                }

            var minMaxArray = angular.copy(service.stats.features);
            minMaxArray.shift();
            minMaxArray = minMaxArray.filter(function (val) {
                return val.properties.value && val.properties.value !== 0;
            });
            var min = Math.min.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            var max = Math.max.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            service.legendValues.max = max;
            service.legendValues.min = min;
            service.legendValues.marker = $translate.instant("dataservice_request");
            service.legendValues.label = $translate.instant("quake_error_filter");
            for (var t = 0, lenh = service.stats.features.length; t < lenh; t++) {
                var value3 = service.stats.features[t];
                value3.properties.min = min;
                value3.properties.max = max;
            }
            //service.geojson.data = [service.stats];
            //if (!analysisService.started)
            service.geojson.style = style;
            //else
            //    analysisService.oldStyle = style;
            notifyObservers(true);
        }

        function updateProjects(data) {
            removeStyle();
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            service.currentColorNumber = 0;
            service.currentColors = [];
            if (service.stats.features && data)
                for (var y = 0, len = service.stats.features.length; y < len; y++) {
                    var value1 = service.stats.features[y];
                    var key1 = y;
                    service.stats.features[key1].properties.value = 0;
                    if (!service.stats.features[key1].properties.defaultText) {
                        service.stats.features[key1].properties.defaultText =
                            service.stats.features[key1].properties.description;
                    } else {
                        service.stats.features[key1].properties.description =
                            service.stats.features[key1].properties.defaultText;
                    }
                    for (var i = 0, lent = data.length; i < lent; i++) {
                        var value2 = data[i];
                        var geoId = parseInt(value1.id);
                        if (matchThematicRow(service.defaults.level, geoId, value2)) {
                            var result = value2.PropertyCount;

                            service.stats.features[key1].properties.value = result;

                            var text = service.stats.features[key1].properties.defaultText;

                            if (result && text) {
                                service.stats.features[key1].properties.description =
                                    text +
                                    " " +
                                    result
                                    + " " + $translate.instant("dataservice_projects");
                            }
                        }
                    }
                }

            var minMaxArray = angular.copy(service.stats.features);
            minMaxArray.shift();
            minMaxArray = minMaxArray.filter(function (val) {
                return val.properties.value && val.properties.value !== 0;
            });
            var min = Math.min.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            var max = Math.max.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            service.legendValues.max = max;
            service.legendValues.min = min;
            service.legendValues.marker = " Proje";
            service.legendValues.label = $translate.instant("projects_error_filter");
            for (var t = 0, lenh = service.stats.features.length; t < lenh; t++) {
                var value3 = service.stats.features[t];
                value3.properties.min = min;
                value3.properties.max = max;
            }
            //service.geojson.data = [service.stats];
            //if (!analysisService.started)
            service.geojson.style = style;
            //else
            //    analysisService.oldStyle = style;
            notifyObservers(true);
        }

        function updateMalls(data) {
            removeStyle();
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            service.currentColorNumber = 0;
            service.currentColors = [];
            if (service.stats.features && data)
                for (var y = 0, len = service.stats.features.length; y < len; y++) {
                    var value1 = service.stats.features[y];
                    var key1 = y;
                    service.stats.features[key1].properties.value = 0;
                    if (!service.stats.features[key1].properties.defaultText) {
                        service.stats.features[key1].properties.defaultText =
                            service.stats.features[key1].properties.description;
                    } else {
                        service.stats.features[key1].properties.description =
                            service.stats.features[key1].properties.defaultText;
                    }
                    for (var i = 0, lent = data.length; i < lent; i++) {
                        var value2 = data[i];
                        var geoId = parseInt(value1.id);
                        if (matchThematicRow(service.defaults.level, geoId, value2)) {
                            var result = value2.PropertyCount;

                            service.stats.features[key1].properties.value = result;

                            var text = service.stats.features[key1].properties.defaultText;

                            if (result && text) {
                                service.stats.features[key1].properties.description =
                                    text +
                                    " " +
                                    result
                                    + " " + $translate.instant("dataservice_malls");
                            }
                        }
                    }
                }

            var minMaxArray = angular.copy(service.stats.features);
            minMaxArray.shift();
            minMaxArray = minMaxArray.filter(function (val) {
                return val.properties.value && val.properties.value !== 0;
            });
            var min = Math.min.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            var max = Math.max.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            service.legendValues.max = max;
            service.legendValues.min = min;
            service.legendValues.marker = $translate.instant("dataservice_malls");
            service.legendValues.label = $translate.instant("mall_error_filter");
            for (var t = 0, lenh = service.stats.features.length; t < lenh; t++) {
                var value3 = service.stats.features[t];
                value3.properties.min = min;
                value3.properties.max = max;
            }
            //service.geojson.data = [service.stats];
            //if (!analysisService.started)
            service.geojson.style = style;
            //else
            //    analysisService.oldStyle = style;
            notifyObservers(true);
        }

        function updateLocations(data) {
            removeStyle();
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            service.currentColorNumber = 0;
            service.currentColors = [];
            if (service.stats.features && data)
                for (var y = 0, len = service.stats.features.length; y < len; y++) {
                    var value1 = service.stats.features[y];
                    var key1 = y;
                    service.stats.features[key1].properties.value = 0;
                    if (!service.stats.features[key1].properties.defaultText) {
                        service.stats.features[key1].properties.defaultText =
                            service.stats.features[key1].properties.description;
                    } else {
                        service.stats.features[key1].properties.description =
                            service.stats.features[key1].properties.defaultText;
                    }
                    for (var i = 0, lent = data.length; i < lent; i++) {
                        var value2 = data[i];
                        var geoId = parseInt(value1.id);
                        if (matchThematicRow(service.defaults.level, geoId, value2)) {
                            var result = value2.PropertyCount;

                            service.stats.features[key1].properties.value = result;

                            var text = service.stats.features[key1].properties.defaultText;

                            if (result && text) {
                                service.stats.features[key1].properties.description =
                                    text +
                                    " " +
                                    result;
                            }
                        }
                    }
                }

            var minMaxArray = angular.copy(service.stats.features);
            minMaxArray.shift();
            minMaxArray = minMaxArray.filter(function (val) {
                return val.properties.value && val.properties.value !== 0;
            });
            var min = Math.min.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            var max = Math.max.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            service.legendValues.max = max;
            service.legendValues.min = min;
            service.legendValues.marker = $translate.instant("dataservice_units");
            service.legendValues.label = $translate.instant("location_error_filter");
            for (var t = 0, lenh = service.stats.features.length; t < lenh; t++) {
                var value3 = service.stats.features[t];
                value3.properties.min = min;
                value3.properties.max = max;
            }
            // service.geojson.onEachFeature = function (feature, layer) {
            //     L.marker(layer.getBounds().getCenter(), {
            //         icon: L.divIcon({
            //             className: 'label',
            //             html: feature.properties.description,
            //             iconSize: [100, 40]
            //         })
            //     }).addTo(service.currentMap);
            // }
            service.geojson.style = style;
            notifyObservers(true);
        }

        function updatePortfolio(data) {
            removeStyle();
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            service.currentColorNumber = 0;
            service.currentColors = [];
            if (service.stats.features && data)
                for (var y = 0, len = service.stats.features.length; y < len; y++) {
                    var value1 = service.stats.features[y];
                    var key1 = y;
                    service.stats.features[key1].properties.value = 0;
                    if (!service.stats.features[key1].properties.defaultText) {
                        service.stats.features[key1].properties.defaultText =
                            service.stats.features[key1].properties.description;
                    } else {
                        service.stats.features[key1].properties.description =
                            service.stats.features[key1].properties.defaultText;
                    }
                    for (var i = 0, lent = data.length; i < lent; i++) {
                        var value2 = data[i];
                        var geoId = parseInt(value1.id);
                        if (matchThematicRow(service.defaults.level, geoId, value2)) {
                            var result = value2.PropertyCount;

                            service.stats.features[key1].properties.value = result;

                            var text = service.stats.features[key1].properties.defaultText;

                            if (result && text) {
                                service.stats.features[key1].properties.description =
                                    text +
                                    " " +
                                    result + " " + $translate.instant("dataservice_units");
                            }
                        }
                    }
                }

            var minMaxArray = angular.copy(service.stats.features);
            minMaxArray.shift();
            minMaxArray = minMaxArray.filter(function (val) {
                return val.properties.value && val.properties.value !== 0;
            });
            var min = Math.min.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            var max = Math.max.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            service.legendValues.max = max;
            service.legendValues.min = min;
            service.legendValues.marker = $translate.instant("dataservice_units");
            service.legendValues.label = $translate.instant("portfolio_error_filter");
            for (var t = 0, lenh = service.stats.features.length; t < lenh; t++) {
                var value3 = service.stats.features[t];
                value3.properties.min = min;
                value3.properties.max = max;
            }
            //service.geojson.data = [service.stats];
            //if (!analysisService.started)
            service.geojson.style = style;
            //else
            //    analysisService.oldStyle = style;
            notifyObservers(true);
        }

        function updateFellows(data, graphType, wholeData) {
            if (graphType !== "hemsehrilik") return false;
            removeStyle();
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            service.currentColorNumber = 0;
            service.currentColors = [];
            if (service.stats.features && data)
                for (var y = 0, len = service.stats.features.length; y < len; y++) {
                    var value1 = service.stats.features[y];
                    var key1 = y;
                    service.stats.features[key1].properties.value = 0;
                    if (!service.stats.features[key1].properties.defaultText) {
                        service.stats.features[key1].properties.defaultText =
                            service.stats.features[key1].properties.description;
                    } else {
                        service.stats.features[key1].properties.description =
                            service.stats.features[key1].properties.defaultText;
                    }
                    for (var i = 0, lent = data.length; i < lent; i++) {
                        var value2 = data[i];
                        var geoId = parseInt(value1.id);
                        if (matchThematicRow(service.defaults.level, geoId, value2)) {
                            var result = value2.CitizenCity;
                            service.stats.features[key1].properties.value = result;
                            var text = service.stats.features[key1].properties.defaultText;
                            if (result && text) {
                                service.stats.features[key1].properties.description =
                                    text + " " + result;// + ")";
                            }
                        }
                    }
                }
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            service.legendValues.marker = "";
            service.legendValues.label = "";

            var datas = [];
            for (var key in wholeData) {
                if (wholeData[key] && typeof wholeData[key] === "object") {
                    datas.push({ key: key, data: wholeData[key].labels });
                }
            }
            for (var p in service.stats.features) {
                if (service.stats.features[p].properties) {
                    var searchFor = service.stats.features[p].properties.value;
                    var selected = datas.filter(function (item) {
                        return item.data && item.data.indexOf(searchFor) > -1;
                    });
                    if (selected.length) {
                        var pIndex = selected[0].data.indexOf(searchFor);
                        service.stats.features[p].properties.color =
                            window.globalColors[pIndex];
                    }
                }
            }

            //if (!analysisService.started)
            service.geojson.style = styleSelected;
            //else
            //    analysisService.oldStyle = styleSelected;

            notifyObservers(true);
        }

        function updateElections(data, hash, wholeData) {
            removeStyle();
            if (!data) return false;
            service.currentColorNumber = 0;
            service.currentColors = [];
            service.winners = data.Winners;
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            for (var y = 0, len = service.stats.features.length; y < len; y++) {
                var value1 = service.stats.features[y];
                service.stats.features[y].properties.value = 0;
                if (!service.stats.features[y].properties.defaultText) {
                    service.stats.features[y].properties.defaultText =
                        service.stats.features[y].properties.description;
                } else {
                    service.stats.features[y].properties.description =
                        service.stats.features[y].properties.defaultText;
                }
                if (data.Winners)
                    for (var i = 0, lent = data.Winners.length; i < lent; i++) {
                        var value2 = data.Winners[i];
                        var geoId = parseInt(value1.id);
                        if (matchThematicRow(service.defaults.level, geoId, value2)) {
                            var result = value2.Option;
                            service.stats.features[y].properties.value = result;
                            var text = service.stats.features[y].properties.defaultText;
                            if (result && text) {
                                service.stats.features[y].properties.description =
                                    text + " " + $translate.instant(result);// + ")";
                            }
                        }
                    }
            }

            hash = hash || "2011genelsecim";

            var datas = [];
            for (var t in wholeData) {
                for (var key in wholeData[t]) {
                    if (wholeData[t][key] && typeof wholeData[t][key] === "object") {
                        datas.push({
                            code: wholeData[t].Code,
                            key: key,
                            data: wholeData[t][key].labels,
                        });
                    }
                }
            }
            for (var p in service.stats.features) {
                if (service.stats.features[p].properties) {
                    var searchFor = service.stats.features[p].properties.value;
                    var selected = datas.filter(function (item) {
                        return (
                            item.data && item.data.indexOf(
                                searchFor === "AK Parti" ? "Ak Parti" : searchFor
                            ) > -1
                        );
                    });
                    if (selected.length) {
                        var filtered = selected.filter(function (item) {
                            return item.code === hash;
                        });
                        if (filtered.length) {
                            var pIndex = filtered[0].data.indexOf(
                                searchFor === "AK Parti" ? "Ak Parti" : searchFor
                            );
                            service.stats.features[p].properties.color =
                                window.globalColors[pIndex];
                        }
                    }
                }
            }

            //if (!analysisService.started)
            service.geojson.style = styleSelected;
            //else
            //    analysisService.oldStyle = styleSelected;

            notifyObservers(true);
        }

        function updateInvestments(data) {
            removeStyle();
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            service.currentColorNumber = 0;
            service.currentColors = [];
            if (service.stats.features && data)
                for (var y = 0, len = service.stats.features.length; y < len; y++) {
                    var value1 = service.stats.features[y];
                    var key1 = y;
                    service.stats.features[key1].properties.value = 0;
                    if (!service.stats.features[key1].properties.defaultText) {
                        service.stats.features[key1].properties.defaultText =
                            service.stats.features[key1].properties.description;
                    } else {
                        service.stats.features[key1].properties.description =
                            service.stats.features[key1].properties.defaultText;
                    }
                    for (var i = 0, lent = data.length; i < lent; i++) {
                        var value2 = data[i];
                        var geoId = parseInt(value1.id);
                        if (matchThematicRow(service.defaults.level, geoId, value2)) {
                            var result = value2.ComparableCount;

                            service.stats.features[key1].properties.value = result;

                            var text = service.stats.features[key1].properties.defaultText;

                            if (result && text) {
                                service.stats.features[key1].properties.description =
                                    text +
                                    " " +
                                    result
                                    + " " + $translate.instant("investment_thematic_piece");
                            }
                        }
                    }
                }

            var minMaxArray = angular.copy(service.stats.features);
            minMaxArray.shift();
            minMaxArray = minMaxArray.filter(function (val) {
                return val.properties.value && val.properties.value !== 0;
            });
            var min = Math.min.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            var max = Math.max.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            service.legendValues.max = max;
            service.legendValues.min = min;
            service.legendValues.marker = $translate.instant("investment_thematic_piece");
            service.legendValues.label = $translate.instant("investment_thematic_listing");
            for (var t = 0, lenh = service.stats.features.length; t < lenh; t++) {
                var value3 = service.stats.features[t];
                value3.properties.min = min;
                value3.properties.max = max;
            }
            //service.geojson.data = [service.stats];
            //if (!analysisService.started)
            service.geojson.style = style;
            //else
            //    analysisService.oldStyle = style;
            notifyObservers(true);
        }

        function removeStyle(force) {
            service.currentColorNumber = 0;
            service.currentColors = [];
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            if (
                service.geojson &&
                service.geojson.data[0] &&
                service.geojson.data[0].features &&
                service.geojson.data[0].features.length
            ) {
                for (
                    var y = 0, len = service.geojson.data[0].features.length; y < len; y++
                ) {
                    service.geojson.data[0].features[y].properties.value = 0;
                    if (service.geojson.data[0].features[y].properties.defaultText)
                        service.geojson.data[0].features[y].properties.description =
                            service.geojson.data[0].features[y].properties.defaultText;

                    //translate city and country names;
                    service.geojson.data[0].features[y].properties.description = $translate.instant(service.geojson.data[0].features[y].properties.description);
                }
            }
            service.geojson.style = style;

            if (!force)
                notifyObservers(true);
        }

        function updateIndices(data, params, hideLabels) {
            service.legendValues.marker = window.currencySymbol + "/m²";

            removeStyle();
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            var marker = window.currencySymbol + "/m²";
            var label = "m² " + $translate.instant("value_filter_analysis_1");
            var highLow = "";

            for (var y = 0, len = service.stats.features.length; y < len; y++) {
                var value1 = service.stats.features[y];
                var key1 = y;
                if (!service.stats.features[key1].properties)
                    continue;
                if (!service.stats.features[key1].properties.defaultText) {
                    service.stats.features[key1].properties.defaultText =
                        service.stats.features[key1].properties.description;
                } else {
                    service.stats.features[key1].properties.description =
                        service.stats.features[key1].properties.defaultText;
                }
                if (params.Level === 7 || params.Level === 8) {
                    value1.properties.defaultText = value1.properties.defaultText + " " + $translate.instant('Parsel');
                    value1.properties.description = value1.properties.defaultText;
                }
                else if (params.Level === 6 && value1.properties.BlockNo) {
                    value1.properties.defaultText = value1.properties.defaultText + " " + $translate.instant('Ada');
                    value1.properties.description = value1.properties.defaultText;
                }
                if (data)
                    for (var i = 0, lent = data.length; i < lent; i++) {
                        var value2 = data[i];
                        var geoId = parseInt(value1.id);
                        if (
                            params.Level === 6 ?
                                geoId === value2.BlockId :
                                params.Level === 7 ?
                                    geoId === value2.ParcelId :
                                    matchThematicRow(params.Level, geoId, value2)
                        ) {
                            var resultPrice = 0;
                            if (params.PriceFilter === 1) {
                                resultPrice =
                                    window.currencyConverter(params.PropertyPriceType === 1 ?
                                        value2.UnitPriceForSale :
                                        value2.UnitPriceForRent, value2.CurrencyId, 0, 0, 1);
                                marker = window.currencySymbol + "/m²";
                                label =
                                    params.PropertyPriceType === 1 ?
                                        "m² " + $translate.instant("value_filter_analysis_1") :
                                        "m² " + $translate.instant("value_filter_analysis_2");
                            } else if (params.PriceFilter === 2) {
                                resultPrice =
                                    window.currencyConverter(params.PropertyPriceType === 1 ?
                                        value2.PriceForSale :
                                        value2.PriceForRent, value2.CurrencyId, 0, 0, 1);
                                marker = window.currencySymbol;
                                label =
                                    params.PropertyPriceType === 1 ?
                                        $translate.instant("value_filter_analysis_3") :
                                        $translate.instant("value_filter_analysis_4");
                            } else if (params.PriceFilter === 3) {
                                resultPrice = value2.Amortization;
                                marker = $translate.instant("year");
                                label = $translate.instant("value_depreciation");
                            } else if (params.PriceFilter === 5) {
                                resultPrice =
                                    params.PropertyPriceType === 1 ?
                                        value2.IndexSale :
                                        value2.IndexRent;
                                marker = $translate.instant("points");
                                label =
                                    params.PropertyPriceType === 1 ?
                                        $translate.instant("value_filter_analysis_00") :
                                        $translate.instant("value_filter_analysis_01");
                            } else if (params.PriceFilter === 4) {
                                resultPrice =
                                    params.PropertyPriceType === 1 ?
                                        (value2.PriceChangeSale * 100).toFixed(2) :
                                        (value2.PriceChangeRent * 100).toFixed(2);

                                if (resultPrice > 0) {
                                    highLow = " <i class='ei-chevron-up'></i>";
                                } else if (resultPrice < 0) {
                                    highLow = " <i class='ei-chevron-down'></i>";
                                } else {
                                    highLow = "";
                                }
                                marker = "%";
                                label = $translate.instant("value_filter_analysis_6");
                            } else if (params.PriceFilter === 6) {
                                resultPrice =
                                    params.PropertyPriceType === 1 ?
                                        (value2.StockChangeSale * 100).toFixed(2) :
                                        (value2.StockChangeRent * 100).toFixed(2);

                                if (resultPrice > 0) {
                                    highLow = " <i class='ei-chevron-up'></i>";
                                } else if (resultPrice < 0) {
                                    highLow = " <i class='ei-chevron-down'></i>";
                                } else {
                                    highLow = "";
                                }
                                marker = "%";
                                label = $translate.instant("value_filter_analysis_6");
                            }
                            else if (params.PriceFilter === 7) {
                                resultPrice =
                                    params.PropertyPriceType === 1 ?
                                        (value2.UnitPriceSaleAnnualChange * 100).toFixed(2) :
                                        (value2.UnitPriceRentAnnualChange * 100).toFixed(2);

                                if (resultPrice > 0) {
                                    highLow = " <i class='ei-chevron-up'></i>";
                                } else if (resultPrice < 0) {
                                    highLow = " <i class='ei-chevron-down'></i>";
                                } else {
                                    highLow = "";
                                }
                                marker = "%";
                                label = $translate.instant("value_filter_analysis_8");
                            }
                            else if (params.PriceFilter === 8) {
                                resultPrice = value2.Yield ? value2.Yield.toFixed(2) : 0;
                                marker = "%";
                                label = $translate.instant("value_yield2");
                            }
                            if (
                                value2.Description === "NA" &&
                                service.stats.features[key1].properties.defaultText
                            ) {
                                value2.Description = service.stats.features[
                                    key1
                                ].properties.defaultText.toLocaleProperCase2("tr-tr");
                            }

                            service.stats.features[key1].properties.value = resultPrice;
                            var text = service.stats.features[key1].properties.defaultText; //value2.Description;
                            if (resultPrice && text && !hideLabels) {
                                if (params.PriceFilter === 3) {
                                    service.stats.features[key1].properties.description =
                                        text + " " + resultPrice + " " + marker;//+ ")";
                                } else if (
                                    params.PriceFilter === 4 ||
                                    params.PriceFilter === 6 ||
                                    params.PriceFilter === 7 ||
                                    params.PriceFilter === 8
                                ) {
                                    service.stats.features[key1].properties.description =
                                        window.lang === 'tr' ? text + " %" + resultPrice + highLow : text + " " + resultPrice + highLow + "%";
                                } else if (params.PriceFilter === 5) {
                                    service.stats.features[key1].properties.description =
                                        text + " " + resultPrice + " " + marker;// + ")";
                                } else {
                                    if (window.lang === 'tr')
                                        service.stats.features[key1].properties.description = text + ' (' + resultPrice.formatMoney(0, ',', '.') + ' ' + marker + ')';
                                    else
                                        service.stats.features[key1].properties.description = text + ' (' + resultPrice.formatMoney(0, '.', ',') + ' ' + marker + ')';
                                }
                            }
                        }
                    }
            }
            var minMaxArray = angular.copy(service.stats.features);

            minMaxArray.shift();
            minMaxArray = minMaxArray.filter(function (val) {
                return val.properties.value && val.properties.value !== 0;
            });

            var min = Math.min.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            var max = Math.max.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );

            if (!hideLabels) {
                service.legendValues.max = max;
                service.legendValues.min = min;
                service.legendValues.marker = marker;
                service.legendValues.label = label;
            } else {
                service.legendValues.max = 0;
                service.legendValues.min = 0;
            }
            for (var t = 0, lenh = service.stats.features.length; t < lenh; t++) {
                var value3 = service.stats.features[t];
                value3.properties.min = min;
                value3.properties.max = max;
            }
            //service.geojson.data = [service.stats];
            //if (!analysisService.started)
            service.geojson.style = style;


            notifyObservers(true);
        }

        //stok ve aylık değişim için
        function getColorRange(d, min, max) {
            if (!d)
                return "transparent";
            const steps = (max - min) / 11;
            return +d >= max - steps ?
                "#a50026" :
                +d >= max - steps * 2 ?
                    "#d73027" :
                    +d >= max - steps * 3 ?
                        "#f46d43" :
                        +d >= max - steps * 4 ?
                            "#fdae61" :
                            +d >= max - steps * 5 ?
                                "#fee08b" :
                                +d >= max - steps * 6 ?
                                    "#ffffbf" :
                                    +d >= max - steps * 7 ?
                                        "#d9ef8b" :
                                        +d >= max - steps * 8 ?
                                            "#a6d96a" :
                                            +d >= max - steps * 9 ?
                                                "#66bd63" :
                                                +d >= max - steps * 10 ?
                                                    "#1a9850" :
                                                    "#006837";
        }

        function style(feature) {
            if (service.defaults.level === 0 || service.defaults.level === 3 || service.defaults.level === 8 || service.defaults.level === 5 || ($rootScope.country !== 'turkiye' && service.defaults.level === 6))
                return {
                    fillColor: "transparent",
                    weight: 2,
                    opacity: 1,
                    color: "#FF0550",
                    dashArray: "2",
                    fillOpacity: 0,

                };
            else {
                const color = getColorRange(
                    feature.properties.value,
                    feature.properties.min,
                    feature.properties.max
                );
                const zoom = service.currentMap.getZoom ? service.currentMap.getZoom() : service.center.zoom;
                return {
                    fillColor: color,
                    weight: 1.2,
                    color: (window.darkMode || zoom > 14) && color !== 'transparent' ? "#ddd" : (color === 'transparent' && zoom <= 14 && !window.darkMode) ? "rgb(132,134,136)" : "#eee", //: "rgb(232,234,236)", "rgb(93,94,96)", "rgb(125,143,155)", //"rgb(144,144,144)", //"rgb(181,181,181)"
                    dashArray: "1",
                    opacity: 1,
                    fillOpacity: 0.8

                };
            }
        }

        function styleSelected(feature) {
            if (service.defaults.level === 0 || service.defaults.level === 3 || service.defaults.level === 8 || service.defaults.level === 5 || ($rootScope.country !== 'turkiye' && service.defaults.level === 6))
                return {
                    fillColor: "transparent",
                    weight: 2,
                    opacity: 1,
                    color: "#FF0550",
                    dashArray: "2",
                    fillOpacity: 0,

                };
            else {
                const color = feature.properties.color;
                const zoom = service.currentMap.getZoom ? service.currentMap.getZoom() : service.center.zoom;
                return {
                    fillColor: color,
                    weight: 1.2,
                    opacity: 1,
                    color: (window.darkMode || zoom > 14) && color !== 'transparent' ? "#ddd" : (color === 'transparent' && zoom <= 14 && !window.darkMode) ? "rgb(132,134,136)" : "#eee",
                    dashArray: "1",
                    fillOpacity: 0.8,

                };
            }
        }

        function zoomToBound(map) {
            map = map || service.currentMap;
            if ($location.search().d) {
                var wkt = unescape($location.search().d);
                var wktr = new Wkt.Wkt();
                wktr.read(wkt);
                var tojs = wktr.toJson();
                var geo = L.geoJson(tojs);
                var bounds = geo.getBounds();
                var lbounds = {
                    northEast: {
                        lat: bounds._northEast.lat,
                        lng: bounds._northEast.lng,
                    },
                    southWest: {
                        lat: bounds._southWest.lat,
                        lng: bounds._southWest.lng,
                    },
                };
                // var centroid = bounds.getCenter();
                // service.center.lat = centroid.lat;
                // service.center.lng = centroid.lng;

                service.bounds = lbounds;
            } else if (service.defaults.level !== 0 && service.stats) {

                var geo = L.geoJson(service.stats);
                var bounds = geo.getBounds();
                var lbounds = {
                    northEast: {
                        lat: bounds._northEast.lat,
                        lng: bounds._northEast.lng,
                    },
                    southWest: {
                        lat: bounds._southWest.lat,
                        lng: bounds._southWest.lng,
                    },
                };

                // var centroid = bounds.getCenter();
                // service.center.lat = centroid.lat;
                // service.center.lng = centroid.lng;

                service.bounds = window.bounds_override ? window.bounds_override : lbounds;

                if (service.defaults.level === 1 || service.defaults.level === 9) {
                    service.cityBounds = service.bounds;
                }

            } else if (service.defaults.level === 0 && service.markers.m1) {
                service.defaults.lat = service.markers.m1.lat;
                service.defaults.lng = service.markers.m1.lng;
                var circle = L.circle([service.defaults.lat, service.defaults.lng], {
                    radius: window.r_override ? window.r_override : 150,
                });
                try {
                    circle.addTo(map);

                    var bounds = circle.getBounds();
                    var lbounds = {
                        northEast: {
                            lat: bounds._northEast.lat,
                            lng: bounds._northEast.lng,
                        },
                        southWest: {
                            lat: bounds._southWest.lat,
                            lng: bounds._southWest.lng,
                        },
                    };

                    // var centroid = bounds.getCenter();
                    // service.center.lat = centroid.lat;
                    // service.center.lng = centroid.lng;

                    service.bounds = lbounds;
                    circle.removeFrom(map);
                }
                catch (err) {
                    //ignored
                }
            }
            else {
                // var lbounds = {
                //     "northEast": {
                //         "lat": 42.10480080000019,
                //         "lng": 44.81603587600034
                //     },
                //     "southWest": {
                //         "lat": 35.808715305999954,
                //         "lng": 25.66549954000005
                //     }
                // };
                service.bounds = window.bounds_override ? window.bounds_override : {};
            }
            $timeout(function () {
                try {
                    map.invalidateSize();
                }
                catch (err) {
                    //ignored
                }
            }, 0);
        }

        function $$IsInside(lat, lng, poly, level) {
            var deferred = $q.defer();
            if (!level && !service.level)
                if (poly) {
                    var x = lat,
                        y = lng;
                    var inside = false;
                    for (var i = 0, j = poly.length - 1; i < poly.length; j = i++) {
                        var xi = poly[i].lat,
                            yi = poly[i].lng;
                        var xj = poly[j].lat,
                            yj = poly[j].lng;
                        var intersect =
                            yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
                        if (intersect) {
                            inside = true;
                            break;
                        }
                    }
                    deferred.resolve(inside);
                } else deferred.resolve(false);
            else
                deferred.resolve(false);
            return deferred.promise;
        }
    }
})();
